import {
  District,
  EducationStatus,
  StatisticDetailResponse,
} from '@/apis/types'

import { TableStatistik } from './TableStatistik'

interface TableDetailProps {
  tableNum: string
  districtId: string
  districtName: string
  yearPeriod: number
  districtLevel: number
  educationLevelId: number
  educationLevelName: string
  educationStatus?: EducationStatus
  districts: District[]
  dataDetail: StatisticDetailResponse
  title: string
  titleWithTag: string
}

export const TableDetail = ({
  dataDetail,
  tableNum,
  districtId,
  districtLevel,
  yearPeriod,
  educationLevelId,
  educationLevelName,
  educationStatus,
  districts,
  titleWithTag,
}: TableDetailProps) => {
  return (
    <TableStatistik
      tableType={dataDetail?.data?.tableType}
      columns={dataDetail?.data?.columns || []}
      data={dataDetail?.data?.rows || []}
      meta={dataDetail?.meta}
      districts={districts}
      districtId={districtId}
      districtLevel={districtLevel}
      tableNum={tableNum}
      educationLevelId={educationLevelId}
      educationLevelName={educationLevelName}
      educationStatus={educationStatus}
      yearPeriod={yearPeriod}
      titleWithTag={titleWithTag}
    />
  )
}
